'use strict';

var _ = require('lodash');
function BookingsTrendCorrectionTransformationService(hepService, configurationService) {
  function isBookingTrendCorrection() {
    var hep = hepService.getSimpleHepProperties();
    return _.get(hep, ['BOOKINGS_TREND_CORRECTION'], false);
  }
  function isDemandDistributionIncremental() {
    return configurationService.isDemandDistributionIncremental();
  }
  function applyBTCFactor(data) {
    if (!isBookingTrendCorrection() || isBookingTrendCorrection() && isDemandDistributionIncremental()) {
      return data;
    }
    return _.map(data, function (entry) {
      var clonedEntry = _.clone(entry);
      if (clonedEntry.regularIsBookingTrendCorrectionRequired && !_.isNil(clonedEntry.regularRemainingDemandFC)) {
        clonedEntry.regularRemainingDemandFC *= clonedEntry.regularBookingTrendCorrectionFactor;
      }
      if (clonedEntry.userValueRegularRemainingDemandFC === undefined) {
        clonedEntry.effectiveRegularRemainingDemandFC = clonedEntry.regularRemainingDemandFC;
      }
      if (clonedEntry.mappedIsBookingTrendCorrectionRequired && !_.isNil(clonedEntry.mappedRemainingDemandFC)) {
        clonedEntry.mappedRemainingDemandFC *= clonedEntry.mappedBookingTrendCorrectionFactor;
      }
      if (clonedEntry.userValueMappedRemainingDemandFC === undefined) {
        clonedEntry.effectiveMappedRemainingDemandFC = clonedEntry.mappedRemainingDemandFC;
      }
      return clonedEntry;
    });
  }
  return {
    applyBTCFactor: applyBTCFactor
  };
}
BookingsTrendCorrectionTransformationService.$inject = ['HepService', 'ConfigurationService'];
module.exports = BookingsTrendCorrectionTransformationService;